import { render, staticRenderFns } from "./CloudPurchase.vue?vue&type=template&id=031da7dc&scoped=true"
import script from "./CloudPurchase.vue?vue&type=script&lang=js"
export * from "./CloudPurchase.vue?vue&type=script&lang=js"
import style0 from "./CloudPurchase.vue?vue&type=style&index=0&id=031da7dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031da7dc",
  null
  
)

export default component.exports